test with mock